import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';
// Selectors
import { selectWorkspaceType } from 'app/store/ui/uiSelectors';
import { selectSelectedPageIds } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Mui
import { Tooltip, ToggleButton } from '@mui/material';
// Icons
import {
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  IndeterminateCheckBox as IndeterminateCheckBoxIcon
} from '@mui/icons-material';
// ToDO: Service
import PageService from 'app/services/PageService';
// End ToDO
// Utils
import { usePagesToolbarContext } from '../utils/usePagesToolbarContext';

const SelectAllToggleButton = () => {
  const { t } = useTranslation();

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const selectedPageIds = useAppSelector(selectSelectedPageIds);
  // ToDO
  const workspaceType = useAppSelector(selectWorkspaceType);

  const { pages } = usePagesToolbarContext();

  const hasAnyPageSelected = useMemo(() => {
    return selectedPageIds.length > 0;
  }, [selectedPageIds]);

  const hasAllPagesSelected = useMemo(() => {
    if ( !pages ) return false;
    return pages.length === selectedPageIds.length;
  }, [pages, selectedPageIds]);

  const handleTogglePagesSelection = useCallback(() => {
    if ( !pages || !pages.length ) return;

    if ( hasAnyPageSelected ) {
      dispatch(PagesToolbarActions.clearSelectedPages());
    } else {
      const pageIds = pages
        .filter((page:any) => page.documentId && page.pageNum)
        .map((page:any) => PageService.toPageId(page.documentId, page.pageNum))
      ;
      dispatch(PagesToolbarActions.setSelectedPages(pageIds));
    }
  }, [dispatch, pages, hasAnyPageSelected]);

  const renderTitle = hasAnyPageSelected ? t('buttons.unselectAll') : t('buttons.selectAll');
  const renderIcon = hasAllPagesSelected
    ? <CheckBoxIcon />
    : hasAnyPageSelected
      ? <IndeterminateCheckBoxIcon />
      : <CheckBoxOutlineBlankIcon />
  ;

  if ( workspaceType === 'episodes' ) return null;
  return (
    <Tooltip title={renderTitle}>
      <ToggleButton
        sx={{ border: 'none', width: 40, height: 40 }}
        value="check"
        selected={hasAnyPageSelected}
        onClick={handleTogglePagesSelection}
        color="primary"
        size="small"
      >{renderIcon}</ToggleButton>
    </Tooltip>
  )
}

export default SelectAllToggleButton